import { runningOnRobot } from "../../api/host-aware";

export async function callRobotApi(apiName: string, body: any = {}) {
  let hmiUrl = runningOnRobot() ? "" : process.env.REACT_APP_HMI_URL;
  if (window.location.href.includes('?signaling=')) {
    const signalingParam = new URLSearchParams(window.location.search).get('signaling');
    hmiUrl = `http://${signalingParam}:28800`;
  }
  const apiUrl = hmiUrl ? `${hmiUrl}/api/${apiName}` : `/api/${apiName}`;
  console.log(`Calling Robot API at ${apiUrl}`);
  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    throw new Error(`API call failed: ${response.statusText}`);
  }
  return response.json();
}

export interface WifiConfig {
  ssid: string;
  ip: string;
  adapter: string;
  availableSSIDs: string[];
  availableAdapters: string[];
  password?: string;
  hotspot?: boolean;
}